<template>
    <div class="cardbg">
        <div class="cardtile">{{message}}</div>
        <div class="cardimg">
            <img src="../../assets/img/cardimg.png" alt="">
        </div>
        <div class="cardbut" @click="doBack">返回</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                appTag:1,//app品牌 0 佳付通 1 富裕钱包 2我是队长
                cpnUid:'',//红包编号
                officeCode:'',
                token:'',
                message:'',
            }
        },
        created () {
            document.title = "权益卡券"
            let appTag = this.$route.query.appTag;
            if(!!appTag){
                this.appTag = appTag;
            }
            let cpnUid = this.$route.query.cpnUid;
            if(!!cpnUid){
                this.cpnUid = cpnUid;
            }
            let officeCode = this.$route.query.officeCode;
            if(!!officeCode){
                this.officeCode = officeCode;
            }
            let token = this.$route.query.token;
            if(!!token){
                this.token = token;
            }
            this.openCpn();//打开卡券
        },
        methods: {
            openCpn(){
                var params = {};
                params["appTag"] = this.appTag;
                params["cpnUid"] = this.cpnUid;
                params["officeCode"] = this.officeCode;
                params["token"] = this.token;
                this.$baseUrl("active/v1/openCpn", params).then((res) => {
                    let data = res.data;
                    if (data.code == "0000") {
                        this.message = data.openMsg;
                    } else {
                        this.$toast(data.msg);
                    }
                });
            },
            doBack(){
                var u = navigator.userAgent;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                var isIOS = u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1; //ios终端
                if(isAndroid){
                    window.JSView.callback();
                }else if(isIOS){
                    var dict = {
                        "name":"LiBaoQin",
                        "gender":"Boy"
                    };             
                    window.webkit.messageHandlers.back.postMessage(dict);
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
@import "../../assets/css/font.scss";
.cardtile{
    font-size: 54px;
    color: #FFF0A5;
    text-align: center;
    font-family: 'zihun5hao-wuwairunheiti';
    font-style: italic;
    margin: 80px 12% 9px;
}
.cardbg{
    background: url(../../assets/img/cardbg.png) no-repeat center center;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    overflow: hidden;
}
.cardimg img{
    width: 100%;
}
.cardbut{
    background: #FFE6AB;
    text-align: center;
    color: #8C0025;
    font-size: 22px;
    height: 49px;
    line-height: 49px;
    border-radius: 24px;
    position: fixed;
    bottom: 10%;
    width: 80%;
    left: 10%;
    box-sizing: border-box;
}
@media screen and ( max-height:736px) {//iphone5
    .cardtile{
        font-size: 44px;
        margin: 40px 15% 0;
    }
    .cardbut{
        bottom: 5%;
    }
}
</style>